/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComputedCommunicationPreference
 */
export interface ComputedCommunicationPreference {
    /**
     * 
     * @type {boolean}
     * @memberof ComputedCommunicationPreference
     */
    isEnabled: boolean;
}

/**
 * Check if a given object implements the ComputedCommunicationPreference interface.
 */
export function instanceOfComputedCommunicationPreference(value: object): value is ComputedCommunicationPreference {
    if (!('isEnabled' in value) || value['isEnabled'] === undefined) return false;
    return true;
}

export function ComputedCommunicationPreferenceFromJSON(json: any): ComputedCommunicationPreference {
    return ComputedCommunicationPreferenceFromJSONTyped(json, false);
}

export function ComputedCommunicationPreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputedCommunicationPreference {
    if (json == null) {
        return json;
    }
    return {
        
        'isEnabled': json['isEnabled'],
    };
}

export function ComputedCommunicationPreferenceToJSON(json: any): ComputedCommunicationPreference {
    return ComputedCommunicationPreferenceToJSONTyped(json, false);
}

export function ComputedCommunicationPreferenceToJSONTyped(value?: ComputedCommunicationPreference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isEnabled': value['isEnabled'],
    };
}

